import React, { Component } from 'react'

import { Card, Button, Table, BackTop, Select, Input, Modal, Tag, message, Tooltip } from 'antd'

import { connect } from 'react-redux'
import { req_page_eca_english_activity_participates, req_downloadfile_eca_activity_participates, req_edit_eca_activity_participate, req_delete_eca_activity_participate } from '../../api'

import { API_BASE, PAGE_SIZE, SORT_FIELD_NAME, SORT_UP_DOWN } from '../../utils/contrains'
import { usrRole } from '../../utils/dataUtil'
import { getNowAcademicYear, getNowAcademicSemester } from '../../utils/dateUtil'
import memoryUtils from '../../utils/memoryUtils'

import EnglishActivityParticipateAddModal from './english-activity-participate-add-modal'
import EnglishActivityParticipateExcelModal from './english-activity-participate-excel-modal'

class UIEnglishActivityParticipates extends Component {
    // 基礎通用參數 //////////////////////////////////////////////    
    state = {
        deviceWidth: 0,
        loading: false,
        userLevel: 'NORMAL',
        items: [],
        item: {},
        pagination: {
            current: 1,
            pageSize: PAGE_SIZE,
            total: 0
        },
        columnSort: SORT_FIELD_NAME,
        orderBy: SORT_UP_DOWN,
        searchField: 'NONE',
        searchValue: '',
        filterStatus: '',

        domnloadFile: '',

        nowAcademicYear: getNowAcademicYear(new Date()),
        nowAcademicSemester: getNowAcademicSemester(new Date()),

        isShowModal: false,
        isEditModal: false,
        isAddModal: false,
        isUploadModal: false

    }

    UNSAFE_componentWillMount() {
        this.init_columns()
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
        this.api_page_items(1)
    }

    // 遠端數據處理 //////////////////////////////////////////////

    api_page_items = async (current) => {
        this.current = current // 保存當前頁，給其他方法可看到
        const { pageSize } = this.state.pagination
        const { searchField, searchValue, columnSort, orderBy, filterStatus } = this.state
        const { token, userCode, role } = this.props.user
        const { activityNid } = this.props.location.state

        var userLevel = usrRole(role)
        this.setState({ userLevel: userLevel })

        this.setState({ loading: true })
        const result = await req_page_eca_english_activity_participates(userCode, userLevel, activityNid, current, pageSize, columnSort, orderBy, searchField, searchValue, filterStatus, token)
        this.setState({ loading: false })

        //console.log(result)
        if (result.total > 0) {
            const { total } = result
            const items = result.data
            const pagination = { current: this.current, pageSize: this.state.pagination.pageSize, total }
            this.setState({ items, pagination })
            //console.log(this.state);
        } else {
            const items = []
            const pagination = { current: 1, pageSize: this.state.pagination.pageSize, total: 0 }
            this.setState({ items, pagination })
        }
    }

    api_downloadfile_items = async () => {
        const { activityNid } = this.props.location.state
        const { searchField, searchValue, filterStatus } = this.state
        const { token, userCode, role } = this.props.user
        var userLevel = usrRole(role)
        this.setState({ userLevel: userLevel })

        const fileUrl = await req_downloadfile_eca_activity_participates(userCode, userLevel, activityNid, searchField, searchValue, filterStatus, token)

        // download file link      
        let a = document.createElement('a');
        a.href = API_BASE + fileUrl;
        a.target = '_blank'
        a.download = '參加人員清單';
        a.click();
    }
 
    api_modify_item = async (item) => {
        const { token } = this.props.user
        await req_edit_eca_activity_participate(item, token)
        //this.api_page_items(this.current)
    }

    api_delete_item = async (key) => {
        const { token } = this.props.user
        const result = await req_delete_eca_activity_participate(key, token)
        if (result.status === 'success') {
            message.success('刪除成功')
            this.api_page_items(this.current)
        } else {
            //console.log(result)
        }
    }

    // 數據配置設定 ////////////////////////////////////////////// 

    init_columns = () => {
        this.columns = [
            {
                title: '單位',
                dataIndex: 'participantsDepart',
                width: 60,
                responsive: ['md'],
                render: (field) => {
                    return (
                        <div className='text-center'>
                            <span style={{ fontSize: '1.3em' }}> {field}</span>
                        </div>
                    )
                },
            },
            {
                title: '學號',
                dataIndex: 'participantsCode',
                width: 40,
                responsive: ['md'],
                render: (field) => {
                    return (
                        <div className='text-center'>
                            <span style={{ fontSize: '1.3em' }}> {field}</span>
                        </div>
                    )
                },
            },
            {
                title: '姓名',
                dataIndex: 'participantsName',
                width: 40,
                render: (field) => {
                    return (
                        <div className='text-center'>
                            <span style={{ fontSize: '1.3em' }}> {field}</span>
                        </div>
                    )
                },
            },
            {
                title: '狀態',
                width: 40,
                responsive: ['md'],
                render: (item) => {
                    const { signStatus } = item
                    return (
                        <div className='text-center'><span>{signStatus.length === 3 ? (<Tag color="green">已獲得</Tag>) : (<Tag color="orange">未獲得</Tag>)}</span> </div>
                    )
                },
            },
            {
                title: '得點',
                width: 30,
                render: (item) => {
                    const { participantsUid, signStatus, getPoints } = item
                    return (
                        <> {signStatus === 'YET' ? (<Input style={{ width: 60, margin: '0 5px', backgroundColor: 'LightYellow' }} defaultValue={getPoints} onChange={(e) => this.handle_ui_field_change(participantsUid, 'ONEPOINT', e)} />) : ''}  </>
                    )
                },
            },
            {
                title: '',
                dataIndex: '',
                width: 60,
                responsive: ['md'],
                render: (item) => {
                    return (
                        <>
                            <button type="button" className="btn btn-outline-dark btn-sm" onClick={() => this.handle_show_ui_modal('delete', item)}><i className="fas fa-user-minus"></i><span> 刪除</span></button>
                        </>
                    )
                },

            },
        ]
    }

    // 操作互動處理 //////////////////////////////////////////////

    resize() {
        this.setState({ deviceWidth: window.innerWidth });
    }

    handle_page_size_change = (current, size) => {
        //console.log(size)
        this.setState({
            pagination: {
                current: current,
                pageSize: size
            }
        }, () => {
            this.api_page_items(current)
        })
    }

    handle_table_change = (pagination, filters, sorter, extra) => {
        if (filters) {
            const status = [...Object.values(filters).filter(Boolean)][0]
            if (status) {
                this.setState({ filterStatus: status }, () => {
                    this.api_page_items(pagination.current)
                });
            } else {
                this.setState({ filterStatus: '' }, () => {
                    this.api_page_items(pagination.current)
                });
            }
        } else {
            this.api_page_items(pagination.current)
        }
    }

    handle_data_refresh = () => {
        this.api_page_items(this.current)
    }

    handle_data_download = () => {
        this.api_downloadfile_items()
    }

    handle_show_ui_modal = (modal, item) => {
        switch (modal) {
            case 'view':
                this.setState({ isShowModal: true, item })
                break;
            case 'edit':
                this.setState({ isEditModal: true, item })
                break;
            case 'add':
                this.setState({ isAddModal: true })
                break;
            case 'delete':
                const { participantsUid } = item
                Modal.confirm({
                    title: `您確定刪除此筆`,
                    onOk: () => {
                        this.api_delete_item(participantsUid)
                    }
                })
                break;
            case 'upload':
                this.setState({ isUploadModal: true, item })
                break;
            case 'download':

                break;
            default:
        }
    }

    handle_pages_back_stautus = () => {
        memoryUtils.pagination.isGoBack = true
        this.props.history.goBack()
    }

    handle_ui_field_change = (target_key, target_field, e) => {
        const value = e.target.value
        const item = {
            participantsUid: target_key,
            getPoints: value,
            condition: target_field
        }
        //console.log(target_key)
        this.api_modify_item(item)

    }
    /////////////////////////////////////////////////////////////     
    render() {
        const activity =  this.props.location.state
        const { activityTitle } = this.props.location.state
        const { loading, items, pagination, searchField, searchValue, deviceWidth, isAddModal, isUploadModal } = this.state

        const title = (
            <span>
                <Button type='link' style={{ color: 'green', fontSize: 25 }} onClick={() => this.handle_pages_back_stautus()} ><i className="fas fa-angle-double-left"></i></Button>
                <span style={{ color: 'green', fontSize: 18 }}>{activityTitle}</span><p />
                <Select value={searchField} style={{ width: 120 }} onChange={value => this.setState({ searchField: value })}>
                    <Select.Option value='NONE'>搜索條件</Select.Option>
                    <Select.Option value='participantsCode'>學號</Select.Option>
                    <Select.Option value='participantsName'>學生姓名</Select.Option>
                </Select>
                <Input placeholder="關鍵字" style={{ width: 80, margin: '0 5px', backgroundColor: 'LightYellow' }} value={searchValue} onChange={event => this.setState({ searchValue: event.target.value })} />
                <Button type='primary' onClick={() => this.api_page_items(1)}><i className="fas fa-search element-hidden"></i><span style={{ marginLeft: '4px' }}> 查詢</span></Button>
                {' '}
                <Tooltip placement="top" title="重新整理"><Button type='primary' onClick={() => this.handle_data_refresh()}><i className="fas fa-sync-alt"></i></Button></Tooltip>
                {' '}
                {deviceWidth > 600 ? (<><Button type='primary' onClick={() => this.handle_data_download()}><i className="fas fa-cloud-download-alt element-hidden"></i><span style={{ marginLeft: '4px' }}> 下載</span></Button></>) : ''}
                {' '}
                {deviceWidth > 600 ? (<><Button type='primary' onClick={() => this.handle_show_ui_modal('add', '')}><i className="fas fa-user-plus"></i><span style={{ marginLeft: '4px' }}>增加</span></Button></>) : ''}
                {' '}
                {deviceWidth > 600 ? (<><Button type='primary' onClick={() => this.handle_show_ui_modal('upload', activity)}><i className="fas fa-users"></i><span style={{ marginLeft: '4px' }}> 上傳</span></Button></>) : ''}

            </span>
        )
        return (
            <Card title={title}>
                <Table
                    bordered
                    scroll={{ y: 480 }}
                    loading={loading}
                    rowKey='Uid'
                    dataSource={items}
                    onChange={this.handle_table_change}
                    pagination={{
                        ...pagination,
                        responsive: true,
                        showQuickJumper: true,
                        showSizeChanger: true,
                        pageSizeOptions: [5, 10, 20, 50, 100],
                        onShowSizeChange: this.handle_page_size_change
                    }}
                    columns={this.columns}
                />
                <Modal
                    destroyOnClose={true}
                    visible={isAddModal}
                    width={500}
                    onOk={() => {
                        this.setState({ isAddModal: false })
                        this.handle_data_refresh()
                    }}
                    onCancel={() => {
                        this.setState({ isAddModal: false })
                    }}
                    cancelButtonProps={{ style: { display: 'none' } }}
                >
                    <EnglishActivityParticipateAddModal activity={this.props.location.state} />
                </Modal>
                <Modal
                    destroyOnClose={true}
                    visible={isUploadModal}
                    width={300}
                    onOk={() => {
                        this.setState({ isUploadModal: false })
                        this.handle_data_refresh()
                    }}
                    onCancel={() => {
                        this.setState({ isUploadModal: false })
                    }}
                    cancelButtonProps={{ style: { display: 'none' } }}
                >
                    <EnglishActivityParticipateExcelModal activity={this.props.location.state} />
                </Modal>
                <BackTop visibilityHeight="80" />
            </Card>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(UIEnglishActivityParticipates)